/* eslint-disable react/prop-types */
import { CircularProgress, Typography, useTheme, useMediaQuery } from '@material-ui/core';
import * as d3 from 'd3';
import React from 'react';
import {
  Bar, BarChart as ReBarChart, Legend, Tooltip, XAxis, YAxis,
  CartesianGrid,
} from 'recharts';
import CustomTooltip from './CustomTooltip';
import ResponsiveContainer from './ResponsiveContainer';

function BarChart({
  height = 300, width, keys, groupKey, data, ready, title, colors, valueFormatter = null, fontSize = 14,
  tooltipTemplate, formatterFunction,
}) {
  const color = d3.scaleOrdinal().range(colors);
  const theme = useTheme();
  // const labelColor = d3.hsl(color).l > 0.5 ? '#000' : '#fff';


  if (useMediaQuery(theme.breakpoints.down('sm'))) {
    fontSize = 'smaller';
  }

  if (useMediaQuery(theme.breakpoints.down('xs'))) {
    fontSize = 'x-small';
  }

  function renderBars() {
    return keys.map((k) => (
      <Bar
        key={k}
        dataKey={k}
        fill={color(k)}
        label={{
          position: 'top',
          formatter: valueFormatter,
          fill: '#3e4044',
          fontSize,
        }}
      />
    ));
  }

  if (!ready) {
    return <CircularProgress />;
  }

  return (
    <>
      <Typography variant="body2" align="center"><strong>{title}</strong></Typography>
      <ResponsiveContainer width="100%" height={height}>
        <ReBarChart
          height={height}
          width={width}
          data={data}
          margin={{
            top: 20, right: 30, left: 0, bottom: 0,
          }}
        >
          <CartesianGrid vertical={false} />
          <XAxis dataKey={groupKey} />
          <YAxis tickFormatter={valueFormatter} />
          {renderBars()}
          <Tooltip cursor={false} content={<CustomTooltip primaryColor={colors[0]} formatterFunction={formatterFunction} valueFormatter={valueFormatter} tooltipTemplate={tooltipTemplate} />} />
          <Legend />
        </ReBarChart>
      </ResponsiveContainer>
    </>
  );
}

export default BarChart;
